export default __webpack_public_path__ + "static/media/forbesCL.3d15487c.webp";